
const state = {
    voter: [],
    personal_info: [],
    contact_info: [],
    seb_voter: [],
    seb_mailing_info: [],
    upload_info: []
}
const getters = {
    VOTER: state => {
        return state.voter;
    },
    PERSONAL_INFO: state => {
        return state.personal_info;
    },
    CONTACT_INFO: state => {
        return state.contact_info;
    },
    SEB_VOTER: state => {
        return state.seb_voter;
    },
    SEB_MAILING_INFO: state => {
        return state.seb_mailing_info;
    },
    UPLOAD_INFO: state => {
        return state.upload_info;
    }
}
const mutations = {
    SET_VOTER: (state, value) => {
        state.voter = value;
    },
    ADD_VOTER: (state, value) => {
        state.voter = [];

        state.voter.push(value);
    },
    SET_PERSONAL_INFO: (state, value) => {
        state.personal_info = value;
    },
    ADD_PERSONAL_INFO: (state, value) => {
        state.personal_info = [];

        state.personal_info.push(value);
    },
    SET_CONTACT_INFO: (state, value) => {
        state.contact_info = value;
    },
    ADD_CONTACT_INFO: (state, value) => {
        state.contact_info = [];

        state.contact_info.push(value);
    },
    SET_SEB_VOTER: (state, value) => {
        state.seb_voter = value;
    },
    ADD_SEB_VOTER: (state, value) => {
        state.seb_voter = [];

        state.seb_voter.push(value);
    },
    SET_SEB_MAILING_INFO: (state, value) => {
        state.seb_mailing_info = value;
    },
    ADD_SEB_MAILING_INFO: (state, value) => {
        state.seb_mailing_info = [];

        state.seb_mailing_info.push(value);
    },
    SET_UPLOAD_INFO: (state, value) => {
        state.upload_info = value;
    },
    ADD_UPLOAD_INFO: (state, value) => {
        state.upload_info = [];

        state.upload_info.push(value);
    }
}
const actions = {
    SAVE_VOTER: async (context, value) => {
        context.commit("ADD_VOTER", value);
    },
    SAVE_PERSONAL_INFO: async (context, value) => {
        context.commit("ADD_PERSONAL_INFO", value);
    },
    SAVE_CONTACT_INFO: async (context, value) => {
        context.commit("ADD_CONTACT_INFO", value);
    },
    SAVE_SEB_VOTER: async (context, value) => {
        context.commit("ADD_SEB_VOTER", value);
    },
    SAVE_SEB_MAILING_INFO: async (context, value) => {
        context.commit("ADD_SEB_MAILING_INFO", value);
    },
    SAVE_UPLOAD_INFO: async (context, value) => {
        context.commit("ADD_UPLOAD_INFO", value);
    }
}

export default {
    state, getters, mutations, actions
}